import React, {Component} from "react";
import { observer } from "mobx-react";
import {fn_requestMemoDelete} from "../../../../function/FnBodySetting";

@observer
class RequestMemoDeleteCheckView extends Component {

    render() {
        const { rootStore } = this.props;
        const layerStore = rootStore.layerStore;
        const settingStore = rootStore.settingStore;

        let typeText = (layerStore.getLayerRequestMemoTypeView === "kitchen")?"주방":"고객"
        let delSeq = (layerStore.getLayerRequestMemoTypeView === "kitchen")?settingStore.getRequestMemoDelete.memo_cd:settingStore.getRequestMemoDelete.seq

        return(
            <div className={"layer_comm layer_alert "+(layerStore.getLayerRequestMemoDeleteView?' layer_open':'')}>
                <div className="bg"></div>
                <div className="layer_content">
                    <div className="article_alert">
                        <h1>{typeText}요청 메시지 삭제</h1>
                        <div className="txt">
                            <p>선택한 요청 메시지를 삭제하시겠습니까?</p>
                        </div>
                        <div className="btn btns">
                            <button type="button" className="btn_cancel" onClick={event => layerStore.setLayerRequestMemoDeleteView(false)}>취소</button>
                            <button type="button"
                                    onClick={e=>fn_requestMemoDelete(rootStore, delSeq)}
                            >확인</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default RequestMemoDeleteCheckView;